// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export default function OcularMotilityLegend() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Typography fontSize="14px">{t("Legend")}</Typography>
      <Grid container display="flex" rowSpacing="8px" columnSpacing="16px">
        <Grid
          item
          container
          xs={12}
          display="flex"
          rowSpacing="8px"
          columnSpacing="16px"
        >
          <Grid item display="flex" alignItems="center" gap="8px">
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: "red",
              }}
            />
            <Typography variant="body2" fontSize="12px">
              {t("Left Eye")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap="8px">
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: "blue",
              }}
            />
            <Typography variant="body2" fontSize="12px">
              {t("Right Eye")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap="8px">
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: "purple",
              }}
            />
            <Typography variant="body2" fontSize="12px">
              {t("Overlapping Values")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap="8px">
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                border: "1px solid black",
                backgroundColor: "white",
              }}
            />
            <Typography variant="body2" fontSize="12px">
              {t("Current Focal Point")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
